module.exports = __webpack_public_path__ + "static/media/GT18_ST_Payment-Types.e957bc64.csv";